import React from 'react';
import { PropTypes } from 'prop-types';

const propTypes = {
  question: PropTypes.object,
  answer: PropTypes.object,
  onSelect: PropTypes.func
};

const defaultProps = {};

export default class SingleChoiceRadioQuestion extends React.Component {

  onChange(choice) {
    this.props.onSelect(choice);
  }

  render() {
    return (
      <div className="rec-questionnaire-question">
        <fieldset>
          <legend><h1 className="h3">{this.props.question.description}</h1></legend>
          {this.props.question.choices.map((choice, index) => {
            const checked = this.props.answer && this.props.answer.value === choice.value;
            return (
              <div
                key={`${this.props.question.id}_choice_${index}`}
                className="rec-form-check-wrap">
                <label
                  htmlFor={`radio-${index}`}
                  className="rec-label-radio">
                  <input
                    type="radio"
                    className="rec-input-hide"
                    id={`radio-${index}`}
                    name="question-choice"
                    checked={checked}
                    value={choice.value}
                    onChange={this.onChange.bind(this, choice)} />
                  <span className="rec-input-radio" />
                  {choice.description}
                </label>
              </div>
            );
          })}
        </fieldset>
      </div>
    );
  }

}

SingleChoiceRadioQuestion.displayName = 'SingleChoiceRadioQuestion';
SingleChoiceRadioQuestion.propTypes = propTypes;
SingleChoiceRadioQuestion.defaultProps = defaultProps;
